/**
 * MESSAGE CREW in the end-of-match views: the game's basic pill — the same pill.short plate, box and tint as the ROUND pill
 * in the other game views (owner 24.9.2026: "message crew, niin siinä pitää käyttää sitä meidän peruspilleriä, mitä
 * muuallakin käytetään. Ei tehdä mitään elementtejä uusiksi, jos ne voidaan käyttää olemassa olevia") — with the word in
 * the condensed face, one control (OD-039). Codex's earlier msgcrew.png plate is gone.
 */
import { KitButton, KitPiece, KitText, type KitTx } from './LobbyKit';
import { ROUND_PILL } from './RoundPill';
import { sfx } from '../audio/sfx';
import { sheet } from '../state/store';

const WORD: KitTx = { id: 'msgcrew.label', text: 'MESSAGE CREW', role: 'command', className: 't-command', x: ROUND_PILL.x + 16, y: ROUND_PILL.y + 18, w: ROUND_PILL.w - 32, h: 40, maxW: ROUND_PILL.w - 32, align: 'center', overflow: 'visible', size: 30 };

export function MsgCrewPill() {
  return (
    <KitButton plate={{ ...ROUND_PILL, id: 'msgcrew' }} testid="btn-message-crew" label="Message crew" onClick={() => { sfx.tap(); sheet.value = 'crew'; }}>
      <KitPiece e={{ ...ROUND_PILL, id: 'msgcrew' }} cls="bd-kit" />
      <KitText t={WORD} />
    </KitButton>
  );
}
